// ~190 views legadas põem `style="padding-top: 5rem !important"` no .wrapper para abrir espaço ao header fixo
// do Metronic. O header agora é estático; o estilo inline vence qualquer CSS, então é removido aqui.
const $ = window.jQuery;

const Layout = function () {

    const limparWrapper = function () {
        $('.page > .wrapper').each(function () {
            this.style.removeProperty('padding-top');
        });
    };

    return {
        init: function () {
            limparWrapper();
        }
    };
}();

module.exports = Layout;
